import { Text } from '@dixa/lib-shared-habla';
import { TagChips } from 'lib-shared-tagging';

import { useConversationRow } from '../../../utils/useConversationRow';

export const ConversationsTableTags = (): JSX.Element | null => {
  const { conversation } = useConversationRow();
  const tags = conversation.tags;

  if (!tags || tags.length === 0) {
    return (
      <Text.Paragraph variant="2" color="tertiary">
        n.a.
      </Text.Paragraph>
    );
  }

  return (
    <TagChips
      tags={tags}
      limit={1}
      onClick={(event) => event.stopPropagation()}
    />
  );
};
